import React from "react";
import { Grid, Button, Stack } from "@mui/material";
import CancelOrderButton from "./CancelOrderButton";
import { useState, useEffect, useMemo } from "react";
import { GetSystemParameterValueByName } from "../../CommonFuntion/SchemaAPICalls";

const OrderActions = ({
  prod_loc_occ,
  occ_profile,
  schema_name,
  user_id,
  schema_id,
  searchParams,
  getMessage,
  RedirectBackToOCC,
  cancelOrder,
  RedirectClick,
  isLoading,
  checkDuplicatePO,
  csvUplaodEnabled,
  childPages,
}) => {
  const [selectedTabs, setSelectedTabs] = useState(() => {
    const savedTabs = localStorage.getItem("selectedTabs");
    return savedTabs ? JSON.parse(savedTabs) : [];
  });
  const [activeTab, setActiveTab] = useState(() => {
    const savedTab = localStorage.getItem("activeTab");
    return savedTab ? parseInt(savedTab) : 0;
  });
  const [userSelection, setUserSelection] = useState(false);
  const [mapTableItemID, setMapTableItemID] = useState(null);

  // Memoize storeGrp string to avoid effect re-runs due to new URLSearchParams object references
  const storeGrp = useMemo(() => searchParams?.get?.("store_grp") || "", [searchParams]);

  // Fetch the system parameter once; derive visibility from cached values and current storeGrp
  const [dontShowForStores, setDontShowForStores] = useState(null);
  const [showCancelButton, setShowCancelButton] = useState(true);

  useEffect(() => {
    if (dontShowForStores !== null) return; // already fetched
    let isMounted = true;
    // Normalize to a Promise in case the mocked function returns non-promise
    Promise.resolve(
      GetSystemParameterValueByName("REACT_APP_DONT_SHOW_CLEAR_ALL_BUTTON_FOR_RBO")
    )
      .then((data) => {
        if (isMounted) setDontShowForStores(Array.isArray(data) ? data : []);
      })
      .catch(() => {
        // On error, default to empty list to avoid hiding unintentionally
        if (isMounted) setDontShowForStores([]);
      });
    return () => { isMounted = false; };
  }, [dontShowForStores]);

  useEffect(() => {
    // Default: show the button if storeGrp is missing or not a string (keeps tests stable)
    if (typeof storeGrp !== "string" || !storeGrp) {
      setShowCancelButton(true);
      return;
    }
    if (Array.isArray(dontShowForStores)) {
      setShowCancelButton(!dontShowForStores.includes(storeGrp));
    }
  }, [storeGrp, dontShowForStores]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <div className="margin80" style={{ marginTop: 20, float: "right" }}>
          <Stack direction="row" spacing={2}>
            {(searchParams.get("OCC") || csvUplaodEnabled) && (
              <>
                {searchParams.get("OCC") && (
                  <Button variant="contained" onClick={RedirectBackToOCC}>
                    {getMessage("btnBackToMarketplace")}
                  </Button>
                )}
               
              </>
            )}
            {showCancelButton && (
              <CancelOrderButton
                prod_loc_occ={prod_loc_occ}
                occ_profile={occ_profile}
                schema_name={schema_name}
                user_id={user_id}
                schema_id={schema_id}
                sessionId={searchParams.get("session_id")}
                store_grp={searchParams.get("store_grp")}
                store_grp_desc={searchParams.get("store_grp_desc")}
                vd_mode={searchParams.get("vd_mode")}
                OrderID={searchParams.get("OrderID")}
                OCC={searchParams.get("OCC")}
                setSelectedTabs={setSelectedTabs}
                setActiveTab={setActiveTab}
                setUserSelection={setUserSelection}
                setMapTableItemID={setMapTableItemID}
                searchParams={searchParams}
                childPages={childPages} // forward to button
              />
            )}
            <Button
              variant="contained"
              onClick={RedirectClick}
            
              sx={{ textTransform: "none" }}
         size="small"
            >
              {getMessage("btnAmendOrder")}
            </Button>
            <Button
              disabled={isLoading || checkDuplicatePO}
              type="submit"
              value="Submit"
              variant="contained"
              sx={{ textTransform: "none" }}
         size="small"
            >
              {isLoading
                ? "Submitting..."
                : checkDuplicatePO
                ? "Checking Duplicate PO..."
                : "Submit"}
            </Button>
          </Stack>
        </div>
      </Grid>
    </Grid>
  );
};

export default OrderActions;
